import React, { useMemo } from "react";
import Dropdown from "../../../components/forms/Dropdown";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { QuestionOption } from "../../../../../api/src/types";
import { useGetCurrentUserQuery } from "../../../api/users";
import { useUpsertAnswerMutation } from "../../../api/answers";
import { ErrorWrapper, InputWrapper } from "./SharedFormStyles";

interface DropdownInputProps {
  question: QuestionWithRelations;
  documentId: string;
}

const DropdownInput: React.FC<DropdownInputProps> = ({
  question,
  documentId,
}) => {
  const selectedOptionId = useMemo(
    () =>
      question.answers[0]?.answerQuestionOptions.map(
        (a) => a.questionOptionId,
      )[0] ?? null,
    [question.answers],
  );

  const { data: user } = useGetCurrentUserQuery();
  const [
    upsertAnswer,
    {
      /*isLoading: isCreating,*/
      isError: isUpsertError,
      /*isSuccess: isCreateSuccess,*/
      /*isSuccess: isUpdateSuccess,*/
      reset: resetUpdateAnswer,
    },
  ] = useUpsertAnswerMutation();

  const handleDropdownChange = (optionId: string) => {
    resetUpdateAnswer();

    if (!user) return;

    const payload = {
      questionId: question.id,
      userId: user.id,
      documentId,
      rootQuestionId: question.rootQuestionId ?? question.id,
      sectionId: question.parentQuestionnaireSectionId,
      questionOptionIds: [optionId],
      serializeDebounceMs: 500,
    };

    void upsertAnswer(payload);
  };

  //const isLoading = isCreating || isUpdating;
  //const hasError = isCreateError || isUpdateError;
  /*const isSuccess =
    (isCreateSuccess || isUpdateSuccess) &&
    !hasError &&
    !isLoading &&
    selectedOption !== null;
  */

  const options = question.questionOptions
    .map((option: QuestionOption) => ({
      label: option.value,
      value: option.id,
    }))
    .sort((a, b) => {
      if (a.label === "United States of America") return -1;
      if (b.label === "United States of America") return 1;
      return 0;
    });

  return (
    <>
      <InputWrapper>
        <Dropdown
          options={options}
          selectedValue={selectedOptionId ?? ""}
          onChange={(e: string) => {
            handleDropdownChange(e);
          }}
          dataTestid={question.id}
        />
        {/* Commenting out the loader and success icon for now as per the request of the design team */}
        {/*
        {isLoading && (
          <IconContainer>
            <Loader spinnerOnly={true} size={isMobile ? 16 : 34} />
          </IconContainer>
        )}
        {isSuccess && (
          <IconContainer>
            <GreenTick size={isMobile ? IconSize.S : IconSize.XL} />
          </IconContainer>
        )}
        */}
      </InputWrapper>
      {isUpsertError && (
        <ErrorWrapper>
          Error saving answer, please refresh the page and try again
        </ErrorWrapper>
      )}
    </>
  );
};

export default DropdownInput;
